function _0xa6fb(_0x15b11f, _0x4f5efa) {
  const _0x457221 = _0x4572();
  return (
    (_0xa6fb = function (_0xa6fb26, _0x1f3470) {
      _0xa6fb26 = _0xa6fb26 - 0x7a;
      let _0x10a116 = _0x457221[_0xa6fb26];
      return _0x10a116;
    }),
    _0xa6fb(_0x15b11f, _0x4f5efa)
  );
}
const _0x18fc10 = _0xa6fb;
(function (_0x52df72, _0x27c5f5) {
  const _0x588ab9 = _0xa6fb,
    _0xbd2b3d = _0x52df72();
  while (!![]) {
    try {
      const _0x55aae8 =
        -parseInt(_0x588ab9(0x7a)) / 0x1 +
        (parseInt(_0x588ab9(0x7c)) / 0x2) * (-parseInt(_0x588ab9(0x86)) / 0x3) +
        parseInt(_0x588ab9(0x87)) / 0x4 +
        (-parseInt(_0x588ab9(0x7f)) / 0x5) * (parseInt(_0x588ab9(0x88)) / 0x6) +
        (parseInt(_0x588ab9(0x7e)) / 0x7) * (-parseInt(_0x588ab9(0x7b)) / 0x8) +
        -parseInt(_0x588ab9(0x81)) / 0x9 +
        (-parseInt(_0x588ab9(0x8b)) / 0xa) * (-parseInt(_0x588ab9(0x8c)) / 0xb);
      if (_0x55aae8 === _0x27c5f5) break;
      else _0xbd2b3d['push'](_0xbd2b3d['shift']());
    } catch (_0x3edfd3) {
      _0xbd2b3d['push'](_0xbd2b3d['shift']());
    }
  }
})(_0x4572, 0xc3b3c);
const CryptoJS = require('crypto-js');
class SignatureGenerator {
  ['SHA256ToString'](_0x182f53) {
    const _0x457e2b = _0xa6fb,
      _0x4db4d3 = CryptoJS[_0x457e2b(0x84)](_0x182f53),
      _0x462445 = _0x4db4d3[_0x457e2b(0x8a)](CryptoJS['enc'][_0x457e2b(0x83)]);
    return _0x462445;
  }
  [_0x18fc10(0x82)](_0x51b5ab) {
    const _0x4fede3 = _0x18fc10,
      _0x572d08 = { _1: process['env'][_0x4fede3(0x89)], _2: _0x51b5ab },
      _0x17717d = [];
    for (const [_0x40917e, _0x1ef9e3] of Object['entries'](_0x572d08)) {
      _0x17717d[_0x4fede3(0x7d)](_0x40917e + '=' + _0x1ef9e3);
    }
    const _0x292161 = this[_0x4fede3(0x85)](_0x17717d[_0x4fede3(0x80)]('&'));
    return _0x292161;
  }
}
const signatureGenerator = new SignatureGenerator();
function _0x4572() {
  const _0xd474bb = [
    '235rqdQPe',
    'join',
    '13836042odNtbB',
    'CreateSignature',
    'Hex',
    'SHA256',
    'SHA256ToString',
    '861jZQiXy',
    '3270228uwfefV',
    '169716voFRQM',
    'REACT_APP_HASH_SECRET_KEY',
    'toString',
    '270mshvlp',
    '2619551WZDpei',
    '1295603YHrLlN',
    '76904PxPcAT',
    '10084uDuEZM',
    'push',
    '609NEfReT',
  ];
  _0x4572 = function () {
    return _0xd474bb;
  };
  return _0x4572();
}
export default signatureGenerator;
